<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Commonly known as the physical manifestation of ADHD, Sam Creedon-Gray has had six careers, three surnames, two new hobbies a year, and one child. When she’s not riding motorcycles, making recycled candles or cooking, Sam indulges in her 22+ year special interest in spirituality, the occult, religion, psychology and science—believing they are all intertwined.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1e5ea6c7